import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid, TextField, Typography } from '@mui/material'
import { Controller, useForm } from "react-hook-form";
import { AxiosInstance, FormActions } from "../../utils/constants";
import * as yup from "yup";
import { InputWithLabel, SelectInputWithLabel } from "./custom-imputs";
import { useEffect, useState } from "react";


const validatorShema = yup.object({
   placa:yup.string().required(),
   cod_tipo_vehiculo:yup.string().required(),
   placa:yup.string().required(),
   modelo:yup.string().required(),
   marca:yup.string().required(),
   anio:yup.number().optional().notRequired().nullable(),
   es_refrigerado:yup.string().required(),
   ind_estado:yup.string().optional().notRequired().nullable(),

});

export const FormVehiculos = ({
    isOpened,
    onSendData,
    vehiculo={},
    mode,
    onCloseVehicle,
    parent_cod
    
})=>{

    const { control, register, handleSubmit, formState: { errors },setValue } = useForm({
        resolver: yupResolver(validatorShema),
        defaultValues: vehiculo
    });
    const [tiposVehiculos,setTiposVehiculos] = useState([]); 
   console.log({vehiculo});

   useEffect(()=>{
    Object.keys(vehiculo).forEach(key=>{
        setValue(key,vehiculo[key]);
     });
   },[vehiculo]);
    
    useEffect(()=>{

         console.log({
            mode,
            vehiculo
         });

        loadInitData();

    },[]);

    const loadInitData = async()=>{

      const {data} = await  AxiosInstance.post("maestros/obtener-tipos-vehiculos",{
            rows_per_page:100,
            page_number:1
        });
        setTiposVehiculos(data?.value?.data?.map(item=>({value:item.cod,label:item.descripcion})));
    }

    const onSubmitForm = (data)=>{
        console.log({data});
        if (  mode !== FormActions.AGREGAR){
            data.cod = vehiculo.cod;
            
        }else{
            data.ind_estado = 'EN REVISION';
        }

        data.cod_empresa_transporte = parent_cod;

        
        onSendData(data);
    }


    return (
        <Dialog
        open={isOpened}
        >
            <DialogTitle>{mode === FormActions.AGREGAR?'Creacion':'Edicion'} de vehiculo</DialogTitle>
            <DialogContent>

                <form onSubmit={handleSubmit(onSubmitForm)} >
                <Grid container spacing={1} >
                <Grid item xs={12} sm={12} md={12} >
                    <Typography>
                        Datos basicos
                    </Typography>
                </Grid>
                    <Grid item xs={6} sm={6} md={6} >
                    <Controller
                        control={control}
                        name="cod_tipo_vehiculo"
                        render={({field})=><SelectInputWithLabel size='small' items={tiposVehiculos} label="Tipo de vehiculo"  errorMessage={errors.cod_tipo_vehiculo?.message}  {...field} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                        control={control}
                        name="placa"
                        render={({field})=><InputWithLabel size='small' label="Placa"  errorMessage={errors.placa?.message}  {...field} />}
                        />

                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                            control={control}
                            name="marca"
                            render={({field})=><InputWithLabel size='small' label="Marca"  errorMessage={errors.marca?.message}  {...field} />}
                        />

                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                            control={control}
                            name="modelo"
                            render={({field})=><InputWithLabel size='small' label="modelo"  errorMessage={errors.modelo?.message}  {...field} />}
                        />

                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                            control={control}
                            name="anio"
                            render={({field})=><InputWithLabel size='small' label="Año"  errorMessage={errors.modelo?.message}  {...field} />}
                        />

                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >
                    <Controller
                        control={control}
                        name="es_refrigerado"
                        render={({field})=><SelectInputWithLabel size='small' items={[
                            { label:"SI", value:"SI"},
                            { label:"NO", value:"NO"},
                        ]} label="¿Es refrigerado?"  errorMessage={errors.cod_tipo_vehiculo?.message}  {...field} />}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >
                    <Controller
                        control={control}
                        name="ind_estado"
                        render={({field})=><SelectInputWithLabel disabled={mode === FormActions.AGREGAR} size='small' items={[
                            { label:"EN REVISION", value:"EN REVISION"},
                            { label:"ACTIVO", value:"ACTIVO"},
                            { label:"INACTIVO", value:"INACTIVO"},
                           
                        ]} label="Estado del vehiculo"  errorMessage={errors.cod_tipo_vehiculo?.message}  {...field} />}
                        />
                    </Grid>
                                    
                </Grid>
                <DialogActions>
                <Button onClick={onCloseVehicle} type="button" size="small" variant="contained" color="secondary" >Cerrar</Button>
                    <Button type="submit" size="small" variant="contained" color="primary" >Guardar</Button>
            </DialogActions>
                </form>
              
                
              
            </DialogContent>
         
        </Dialog>
    )

}